import { render, staticRenderFns } from "./modal_iniciar_consulta_telemedicina.vue?vue&type=template&id=14b50890&scoped=true"
import script from "./modal_iniciar_consulta_telemedicina.vue?vue&type=script&lang=js"
export * from "./modal_iniciar_consulta_telemedicina.vue?vue&type=script&lang=js"
import style0 from "./modal_iniciar_consulta_telemedicina.vue?vue&type=style&index=0&id=14b50890&prod&scoped=true&lang=css"
import style1 from "./modal_iniciar_consulta_telemedicina.vue?vue&type=style&index=1&id=14b50890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b50890",
  null
  
)

export default component.exports